import React from 'react';
import DHRouter from '~/components/DHRouter';
import OfficeList from './components/OfficeList';
import OfficeUserList from './components/OfficeUserList';
import OfficeDetails from './components/OfficeDetails';

export default () => (
  <DHRouter>
    <OfficeList path="/" />
    <OfficeDetails path="/:officeId" />
    <OfficeUserList path="/:officeId/users" />
  </DHRouter>
);
